import { Trans, useTranslation } from 'next-i18next/pages';
import Image from 'next/image';

import { getButtonClassName } from '@pflegia/ui/shared/button';
import ButtonLink from '@pflegia/ui/shared/button-link/ButtonLink';
import Headline from '@pflegia/ui/shared/headline/Headline';

import caregiversHoldingSmartphone from '@public/assets/both-checking-phone-smiling-high-quality.png';

import { SALARY_CALCULATOR } from '@shared/application/constants';

const SalaryCalculatorTeaser: React.FC = () => {
  const { t } = useTranslation('landingPage', { keyPrefix: 'salaryCalculatorTeaser' });

  return (
    <div
      className='bg-primary-100 overflow-hidden rounded-4xl px-4 py-8 md:px-10 md:py-10 lg:px-16 lg:py-14'
      data-testid='salary-calculator-teaser'>
      <div className='flex flex-col items-center lg:flex-row'>
        <div className='w-full lg:col-span-7 lg:w-7/12'>
          <h2
            className='text-xl leading-8 font-normal text-black md:text-2xl lg:text-2xl xl:text-3xl xl:font-medium'
            data-testid='salary-calculator-teaser-title'>
            {t('title')}
          </h2>
          <div
            className='w-full lg:mt-4 [&_svg]:mt-10 [&_svg]:-ml-8 [&_svg]:h-14 [&_svg]:w-8 [&_svg]:rotate-30 lg:[&_svg]:mt-8 lg:[&_svg]:-ml-4 lg:[&_svg]:h-16 lg:[&_svg]:w-9 xl:[&_svg]:h-20 xl:[&_svg]:w-10 [&>div]:items-start [&>div]:justify-start'
            data-testid='salary-calculator-teaser-headline'>
            <Headline
              showArrow
              arrowPosition='right'
              titleClassName='!mb-0 !text-left'
              title={
                <span className='text-xl leading-8 font-normal text-black md:text-2xl xl:text-3xl xl:font-medium'>
                  <Trans
                    components={{
                      span: (
                        <span className='font-handwriting text-main-blue align-text-top text-2xl font-normal tracking-wide whitespace-nowrap uppercase md:text-3xl xl:text-5xl' />
                      ),
                    }}
                    i18nKey='landingPage:salaryCalculatorTeaser.headline'
                    defaults={t('headline')}
                    t={t}
                  />
                </span>
              }
            />
          </div>
          <div className='-mt-14 lg:-mt-12'>
            <ButtonLink
              href={SALARY_CALCULATOR}
              className={getButtonClassName('primary', 'w-fit px-5 py-3 text-[14px] text-white lg:text-base')}
              dataTestId='salary-calculator-teaser-cta'>
              {t('cta')}
            </ButtonLink>
          </div>
        </div>

        <div
          className='flex h-full w-full items-end justify-center self-end pt-8 lg:w-5/12 lg:justify-end'
          data-testid='salary-calculator-teaser-image'>
          <Image
            src={caregiversHoldingSmartphone}
            alt={t('imageAlt')}
            width={500}
            height={600}
            sizes='(max-width: 1024px) 384px, (max-width: 1280px) 448px, 500px'
            className='-mb-10 h-auto w-full max-w-sm origin-bottom scale-110 object-contain object-bottom select-none lg:-mb-20 lg:max-w-md xl:-mb-40 xl:max-w-full xl:scale-125'
          />
        </div>
      </div>
    </div>
  );
};

export default SalaryCalculatorTeaser;
